import { render, staticRenderFns } from "./ProductColorComponent.vue?vue&type=template&id=544cb15b&scoped=true"
import script from "./ProductColorComponent.vue?vue&type=script&lang=js"
export * from "./ProductColorComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductColorComponent.vue?vue&type=style&index=0&id=544cb15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544cb15b",
  null
  
)

export default component.exports